import React, {useEffect} from "react";
import {useStores} from "../../../../stores/useStores";
import {observer} from "mobx-react-lite";
import ViewNoticeTemplate from "../../../../components/templates/notices/viewNoticeTemplate";
import {runInAction} from "mobx";
import {useTranslation} from "react-i18next";
import {useHistory, useParams} from "react-router";
import {useAsync} from "react-async";
import {ToastMessageStatus} from "../../../../components/atoms/toastMessage/toastMessage";
import {RoutePaths} from "../../../../shared/routePaths";

export interface IViewNoticeProps {}

const ViewNotice: React.FC<IViewNoticeProps> = () => {
  const {
    uiStore: {noticesUiStore, toastMessageStore},
    domainStore: {noticesDomainStore}
  } = useStores();

  const {t} = useTranslation(["translation", "notice"]);
  const history = useHistory();

  const {id} = useParams<{id: string}>();
  const {isInitial, isLoading, isPending, run} = useAsync({
    deferFn: () => noticesDomainStore.loadEditableNotice(id),
    onReject: () => {
      toastMessageStore.displayToastMessage(
        t("notice:errors.invalidNotice"),
        ToastMessageStatus.Danger,
        8000
      );
      noticesUiStore.resetIsViewingNoticeFlag();
      history.push(RoutePaths.Notices);
    }
  });

  useEffect(() => {
    if (
      id &&
      !isLoading &&
      !isPending &&
      isInitial &&
      noticesDomainStore.editableNotice.id === ""
    ) {
      run();
    }
  }, [
    id,
    isLoading,
    isPending,
    isInitial,
    run,
    noticesDomainStore.editableNotice.id
  ]);

  useEffect(() => {
    runInAction(() => {
      noticesUiStore.isViewingNotice = true;
    });
  }, [noticesUiStore]);

  return <ViewNoticeTemplate notice={noticesDomainStore.editableNotice} />;
};

export default observer(ViewNotice);
